import { type User } from "./api/user";
import { PlanTypes } from "./plans";

type UserProperties = {
  subscription_type: PlanTypes;
  full_name: string;
  email: string;
  org_id: number;
  org_name: string;
};

export enum AmplitudePropertyConstraint {
  REQUIRED = "REQUIRED",
  OPTIONAL = "OPTIONAL",
}

export enum AmplitudeEventType {
  SIGN_UP = "Account Signed Up",
}

type BaseEventProperties = {
  page_url: string;
};

type SignUpProperties = BaseEventProperties & {
  org_code: string;
  selected_experience: string;
};

type AnyEventProperties = BaseEventProperties | SignUpProperties;

type Events = {
  [AmplitudeEventType.SIGN_UP]: SignUpProperties;
};

type AmplitudeUserProperties = {
  user_id: User["userProfileId"];
  user_properties?: Partial<UserProperties>;
};

type AmplitudeEventProperties<
  T = unknown,
  Constraint = AmplitudePropertyConstraint.REQUIRED
> = {
  event_properties: T extends AnyEventProperties
    ? Constraint extends AmplitudePropertyConstraint.REQUIRED
      ? T
      : Partial<T>
    : T extends AmplitudeEventType
    ? Constraint extends AmplitudePropertyConstraint.REQUIRED
      ? Events[T]
      : Partial<Events[T]>
    : never;
};

export type AmplitudeEvent<
  T = unknown,
  K = AmplitudePropertyConstraint.REQUIRED
> = T extends AmplitudeEventType | AnyEventProperties
  ?
      | AmplitudeEventProperties<T, K>
      | (AmplitudeUserProperties & AmplitudeEventProperties<T, K>)
  : never;

export type AmplitudeTrack<T = unknown> = T extends AmplitudeEventType
  ? AmplitudeEvent<T> & {
      event_type: T;
    }
  : never;
